<template>
  <v-container fluid v-if="show">
    <v-dialog v-model="show" max-width="500px">
      <v-card>
        <v-card-title class="secondary white--text d-flex align-center justify-space-between">
          <span class="header-font" style="font-size: 22px;"> 
            <v-icon style="font-size: 18px;" color="white" class="mr-2">share</v-icon>
            {{ title }}
          </span>
        </v-card-title>
        <v-card-subtitle class="secondary py-2 white--text d-flex align-center justify-space-between">
          <span class="subheader-font body-2"> {{ subtitle }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-2 mt-5">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" class="pa-0 ma-0">
                <p class="body-1 font-weight-bold primary--text mb-0">Link</p>
              </v-col>
              <v-col cols="12" class="py-0 px-1 d-flex justify-space-between align-end">
                <v-text-field readonly :value="link" hide-details class="mr-2 py-0 slim-input" ref="linkInputRef"/>
                <v-btn color="secondary" small @click="copyClipboard('link')" class="elevation-0">
                  <v-icon small>content_copy</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" class="pa-0 ma-0 mt-5">
                <p class="body-1 font-weight-bold primary--text mb-0">Embed</p>
              </v-col>
              <v-col cols="12" class="py-0 px-1 d-flex justify-space-between align-end">
                <v-text-field readonly :value="embed" class="mr-2 py-0 slim-input" hide-details ref="embedInputRef"/>
                <v-btn color="secondary" small @click="copyClipboard('embed')" class="elevation-0">
                  <v-icon small>content_copy</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" class="pa-0 ma-0 mt-5">
                <p class="body-1 font-weight-bold primary--text mb-0">IFrame</p>
              </v-col>
              <v-col cols="12" class="py-0 px-1 d-flex justify-space-between align-end">
                <v-text-field readonly :value="iframe" class="mr-2 py-0 slim-input" hide-details ref="iframeInputRef"/>
                <v-btn color="secondary" small @click="copyClipboard('iframe')" class="elevation-0">
                  <v-icon small>content_copy</v-icon>
                </v-btn>
              </v-col>
              <v-row v-if="isMarca" class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0 mt-5">
                  <p class="body-1 font-weight-bold primary--text mb-0">IFrame AMP</p>
                </v-col>
                <v-col cols="12" class="py-0 px-1 d-flex justify-space-between align-end">
                  <v-text-field readonly :value="iframeAMP" class="mr-2 py-0 slim-input" hide-details ref="iframeAMPInputRef"/>
                  <v-btn color="secondary" small @click="copyClipboard('iframeAMP')" class="elevation-0">
                    <v-icon small>content_copy</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-col cols="12 pt-3 px-0">
                <v-alert color="success lighten-3 mb-0 body-2" dense v-if="textAlert">{{textAlert}} </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-6 pb-4 d-flex justify-end">
          <v-btn :color="$vuetify.theme.dark ? 'white' : 'secondary'" rounded outlined class="elevation-0 monospace-font px-4" @click="onCancelClick()">{{$t('general.cancel')}}</v-btn>
          <v-btn rounded class="elevation-0 monospace-font white--text px-4" color="primary" @click="onSaveClick()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import * as _ from 'lodash';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/';

export default {
  name: 'ChartExportLinksModal',
  components: {
  },
  filters: {
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    link(){
      return `${API_URL}${this.chart.id}/key/${this.chart.awsKey}/compId/${this.chart.componentId}/catId/${this.chart.categoryId}/tId/${this.chart.toolId}`;
    },
    embed(){
      let width = this.isMarca ? "100%" : this.chart.width;
      let height = this.isMarca ? "100%" : this.chart.height;
      return `<embed src="${this.link}" width="${width}" height="${height}"/>`;
    },
    iframe(){
      let width = this.isMarca ? "100%" : this.chart.width;
      let height = this.isMarca ? "100%" : this.chart.height;
      return `<iframe src="${this.link}" width="${width}" height="${height}"/>`;
    },
    iframeAMP(){
      let width = this.isMarca ? "100%" : this.chart.width;
      let height = this.isMarca ? "100%" : this.chart.height;
      //AMP need to close tags with '</amp-iframe>'. '/>' is not valid.
      return `<amp-iframe width="${width}" height="${height}" src="${this.link}" layout="responsive" sandbox="allow-scripts allow-same-origin" frameborder="0"></amp-iframe>`;
    },
    isMarca(){
      return this.currentUser.clientId == 10552;
    }
  },
  props:{
    title:{
      type:String,
      default: ""
    },
    subtitle:{
      type:String,
      default: ""
    }
  },
  data() {
    return {
      chart: null,
      show: false,
      textAlert: ""
    };
  },
  created() {
  },
  methods: {
    open(chart = {}){
      this.chart = chart;
      this.show = true;
    },
    close(){
      this.chart = null;
      this.show = false;
    },
    onCancelClick(){
      this.close()
    },
    async onSaveClick(){
      this.close()
    },
    copyClipboard(input){
      let el = this.$refs[`${input}InputRef`].$el;
      if(el.focus){
        el.focus();
      }
      if(el.select){
        el.select();
      }
      navigator.clipboard.writeText(this[input]).then(() => {
        this.textAlert = this.$t("general.copiedToClipboard");
        setTimeout(() => {
          this.textAlert = "";
        },2525)
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      }); 
    }
  }
};
</script>
